import PropTypes from 'prop-types';
/**
 *  keep in sync with AjaxUtils.getAjaxErrorMessages
 *  Example in PrincipalsSignupErrorsShape
 *  {
 *  	FIELDNAME : [AjaxErrorMessageShape],
 *  	global: [AjaxErrorMessageShape],
 *  	hasErrors: boolean,
 *  	preventSubmit: boolean
 *  }
 */

// keep in sync with AjaxErrorMessage.java
export const AjaxErrorMessageShape = PropTypes.shape({
	field: PropTypes.string,
	code: PropTypes.string,
	message: PropTypes.string
});
